export default __webpack_public_path__ + "static/media/Esmaeelinejad.6a36bbf8.png";